// stores/RootStore.js
import { makeObservable, observable } from "mobx";
import AuthStore from './authStore';
import UserStore from './userStore';
import ClientStore from './clientStore';
import BriefStore from './briefStore';
import ProjectStore from './projectStore';
import ProjectPlanStore from './projectPlanStore';
import EvaluationStore from './evaluationStore';
import QuoteStore from './quoteStore';
import VoucherStore from './voucherStore';
import UIStore from './uiStore';
import WebAuthnStore from './webauthnStore';

export default class RootStore {
  authStore;
  userStore;
  clientStore;
  briefStore;
  projectStore;
  projectPlanStore;
  evaluationStore;
  quoteStore;
  voucherStore;
  uiStore;
  webAuthnStore;

  constructor() {
    this.authStore = new AuthStore(this);
    this.userStore = new UserStore(this);
    this.clientStore = new ClientStore(this);
    this.briefStore = new BriefStore(this);
    this.projectStore = new ProjectStore(this);
    this.projectPlanStore = new ProjectPlanStore(this);
    this.evaluationStore = new EvaluationStore(this);
    this.quoteStore = new QuoteStore(this);
    this.voucherStore = new VoucherStore(this);
    this.uiStore = new UIStore(this);
    this.webAuthnStore = new WebAuthnStore(this);

    makeObservable(this, {
      authStore: observable,
      userStore: observable,
      clientStore: observable,
      briefStore: observable,
      projectStore: observable,
      projectPlanStore: observable,
      evaluationStore: observable,
      quoteStore: observable,
      voucherStore: observable,
      uiStore: observable,
      webAuthnStore: observable,
    });
  }
}